import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";
import ComponentCard from "../../../../../shared/ui/common/ComponentCard"; // Adjust import path as needed

interface PatientExportDataCardProps {
    onExport: () => void;
    loading?: boolean;
}

export default function PatientExportDataCard({ onExport, loading }: PatientExportDataCardProps) {
    const { t } = useTranslation();

    return (
        <ComponentCard
            title={
                <div className="flex justify-between items-center w-full">
                    <span>{t("patient.exportData")}</span>
                </div>
            }
        >
            <div className="flex flex-col gap-5 xl:flex-row xl:items-center xl:justify-between">
                <div className="flex flex-col items-center w-full gap-6 xl:flex-row">
                    <div className="order-3 xl:order-2 text-center xl:text-left">
                        <p className="text-sm text-content-tertiary max-w-lg">
                            {t("patient.exportDataDesc")}
                        </p>
                    </div>

                    <div className="flex items-center order-2 gap-2 grow xl:order-3 xl:justify-end">
                        <button
                            onClick={onExport}
                            disabled={loading}
                            className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            <Download className="w-4 h-4" />
                            {loading ? "Exporting..." : t("patient.exportData")}
                        </button>
                    </div>
                </div>
            </div>
        </ComponentCard>
    );
}
